import { Component } from "@angular/core";
import {
  NavController,
  NavParams,
  ViewController,
  AlertController
} from "ionic-angular";
import { EmailComposer } from "@ionic-native/email-composer";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { ContactModel } from "./contact.model";
import { CallNumber } from "@ionic-native/call-number";
import { Block } from "../../models/block.interface";
import { ToastProvider } from "../../providers/toast/toast";
import CryptoJS from "crypto-js";
import { TimelinePage } from "../timeline/timeline";
import { UserProvider } from "../../providers/user/user";
import { PhotoViewer } from "@ionic-native/photo-viewer";
import { LoadingProvider } from "../../providers/loading/loading";
import { DocusignProvider } from "../../providers/docusign/docusign";

@Component({
  selector: "contact-card-page",
  templateUrl: "contact-card.html"
})
export class ContactCardPage {
  contact: ContactModel;
  block: Block;
  user: any;
  inputData: any;
  correctBlock: boolean;
  newCode: string = "";
  blocksWithSameBarcode: Block[];
  hashedCodes: string;
  lat: number;
  long: number;
  hasBarcode: boolean;
  scannedBy: string;
  addedBy: string;
  signed= false;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private emailComposer: EmailComposer,
    public inAppBrowser: InAppBrowser,
    public callNumber: CallNumber,
    public viewCtrl: ViewController,
    public toast: ToastProvider,
    public alertCtrl: AlertController,
    private userservice: UserProvider,
    private photoViewer: PhotoViewer,
    public loading: LoadingProvider,
    public docusign: DocusignProvider
  ) {
    this.loading.show("Fetching Details...");
    this.block = this.navParams.get("block");
    this.user = this.navParams.get("user");
    this.blocksWithSameBarcode = this.navParams.get("blocksWithSameBarcode");
    this.contact = new ContactModel(this.block);
    this.lat = this.block.lats[this.block.lats.length - 1];
    this.long = this.block.longs[this.block.longs.length - 1];
    this.hasBarcode = this.navParams.get("hasBarcode");
    this.userservice
      .getUsername(this.block.users[this.block.users.length - 1])
      .then((res: any) => {
        this.scannedBy = res.slice(0, res.indexOf(" ") + 2) + ".";
        this.userservice.getUsername(this.block.users[0]).then((res: any) => {
          this.addedBy = res.slice(0, res.indexOf(" ") + 2) + ".";
          this.loading.hide();
        });
      });
      this.toast.show('You will receive a document to sign in your inbox to agree to this transaction.')
  }

  sendMail() {
    let alert = this.alertCtrl.create({
      enableBackdropDismiss: false,
      title: "Email",
      message: "Which person would you like to email?",
      buttons: [
        {
          text: "Email Seller",
          handler: () => {
            this.userservice
              .getspecificuser(this.block.users[this.block.users.length - 1])
              .then((user: any) => {
                if (user.email.length <= 0) {
                  this.toast.quickShow(
                    "Error finding email for seller. Try again later."
                  );
                } else {
                  let email = {
                    to: user.email,
                    subject: "",
                    body: ""
                  };
                  this.emailComposer.open(email);
                }
              });
          }
        },
        {
          text: "Email Manufacturer",
          handler: () => {
            this.userservice
              .getspecificuser(this.block.users[0])
              .then((user: any) => {
                if (user.email.length <= 0) {
                  this.toast.quickShow(
                    "Error finding email for manufacturer. Try again later."
                  );
                } else {
                  let email = {
                    to: user.email,
                    subject: "",
                    body: ""
                  };
                  this.emailComposer.open(email);
                }
              });
          }
        },
        {
          text: "Go Back",
          role: "cancel",
          handler: () => {}
        }
      ]
    });
    alert.present();
  }

  openInAppBrowser(website: string) {
    this.inAppBrowser.create(website, "_blank", "location=yes");
  }

  call() {
    let alert = this.alertCtrl.create({
      enableBackdropDismiss: false,
      title: "Call",
      message: "Which person would you like to call?",
      buttons: [
        {
          text: "Call Seller",
          handler: () => {
            this.userservice
              .getspecificuser(this.block.users[this.block.users.length - 1])
              .then((user: any) => {
                if (user.cell.length <= 0) {
                  this.toast.quickShow(
                    "Error finding cell number for seller. Try again later."
                  );
                } else {
                  this.callNumber
                    .callNumber(user.cell, true)
                    .then(() => console.log("Launched dialer!"))
                    .catch(() =>
                      this.toast.quickShow("Error launching phone application!")
                    );
                }
              });
          }
        },
        {
          text: "Call Manufacturer",
          handler: () => {
            this.userservice
              .getspecificuser(this.block.users[0])
              .then((user: any) => {
                if (user.cell.length <= 0) {
                  this.toast.quickShow(
                    "Error finding cell number for manufacturer. Try again later."
                  );
                } else {
                  this.callNumber
                    .callNumber(user.cell, true)
                    .then(() => console.log("Launched dialer!"))
                    .catch(() =>
                      this.toast.quickShow("Error launching phone application!")
                    );
                }
              });
          }
        },
        {
          text: "Go Back",
          role: "cancel",
          handler: () => {}
        }
      ]
    });
    alert.present();
  }

  chat() {
    this.toast.quickShow("Chat function not enabled right now!");
  }

  wrong() {
    let alert = this.alertCtrl.create({
      enableBackdropDismiss: false,
      title: "Confirm Wrong Item",
      message:
        "Are you sure you want to void this item? It can not be reversed.",
      buttons: [
        {
          text: "Yes",
          handler: () => {
            this.correctBlock = false;
            let data = "wrong";
            this.viewCtrl.dismiss(data);
          }
        },
        {
          text: "No",
          role: "cancel",
          handler: () => {}
        }
      ]
    });
    alert.present();
  }

  correct() {
    this.correctBlock = true;
  }

  map(){
    this.toast.show('Thanks for signing the document! You can confirm the item now.');
    this.signed = true;
  }
  updateCode() {
    if (this.hasBarcode) {
      this.hashedCodes = "";
      this.hashedCodes = CryptoJS.SHA256(
        this.block.barcode + this.newCode
      ).toString(CryptoJS.enc.CryptoHex);
      let comboUsed = false;
      for (let x = 0; x < this.blocksWithSameBarcode.length; x++) {
        if (this.blocksWithSameBarcode[x].hashedCodes == this.hashedCodes) {
          comboUsed = true;
        }
      }
      if (this.hashedCodes == this.block.hashedCodes) {
        this.toast.show("Code has to be unique!");
        this.newCode = "";
      } else if (comboUsed) {
        this.toast.show(
          "Code is not unique or already has been used! Please try again."
        );
        this.newCode = "";
      } else if (this.newCode == "") {
        this.toast.show("Code cannot be blank!");
      } else {
        let data = this.newCode;
        this.viewCtrl.dismiss(data);
      }
    }
  }

  updateNoCode() {
    if (!this.hasBarcode) {
      let data = "none";
      this.viewCtrl.dismiss(data);
    }
  }

  openMap() {
    this.navCtrl.push("ViewmapPage", { block: this.block, index: -1 });
  }

  openPath() {
    this.navCtrl.push(TimelinePage, { block: this.block, user: this.user });
  }

  openImg(img) {
    this.photoViewer.show(img);
  }
}



// WEBPACK FOOTER //
// ./src/pages/contact-card/contact-card.ts